/**
 * Tag operations — list, create, delete, update.
 */

import type { ArbiClient, components } from '@arbidocs/client'
import { requireData } from '../errors.js'

type UpdateTagRequest = components['schemas']['UpdateTagRequest']

export async function listTags(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/tag/list'), 'Failed to fetch tags')
}

export async function createTag(
  arbi: ArbiClient,
  options: {
    name: string
    workspaceId?: string
    tagType?: components['schemas']['TagFormat']
    instruction?: string | null
    shared?: boolean
  }
) {
  return requireData(
    await arbi.fetch.POST('/v1/tag/', {
      body: {
        name: options.name,
        tag_type: options.tagType ?? { type: 'checkbox', options: [] },
        instruction: options.instruction ?? null,
        shared: options.shared ?? false,
      },
    }),
    'Failed to create tag'
  )
}

export async function deleteTag(arbi: ArbiClient, tagId: string) {
  return requireData(
    await arbi.fetch.DELETE('/v1/tag/{tag_ext_id}', {
      params: { path: { tag_ext_id: tagId } },
    }),
    'Failed to delete tag'
  )
}

export async function updateTag(arbi: ArbiClient, tagId: string, body: UpdateTagRequest) {
  return requireData(
    await arbi.fetch.PATCH('/v1/tag/{tag_ext_id}', {
      params: { path: { tag_ext_id: tagId } },
      body,
    }),
    'Failed to update tag'
  )
}
